import React, { useEffect, useMemo } from "react";
import { useReducedMotion } from "framer-motion";
import "./AnniversaryDecoration.scss";

const STREAMER_COUNT = 20;
const PALETTE = ["#6E4B28", "#FDF6EC", "#D4A017", "#E8871E", "#8B2E2E"];

function randomBetween(min, max) {
  return min + Math.random() * (max - min);
}

export function AnniversaryDecoration() {
  const prefersReducedMotion = useReducedMotion();

  const streamers = useMemo(() => {
    if (prefersReducedMotion) return [];

    return Array.from({ length: STREAMER_COUNT }, (_, id) => ({
      id,
      leftPct: randomBetween(0, 100),
      delaySec: randomBetween(0, 6),
      durationSec: randomBetween(6, 11),
      rotateDeg: randomBetween(180, 540),
      color: PALETTE[id % PALETTE.length],
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (prefersReducedMotion) return;

    let cancelled = false;

    import("canvas-confetti").then(({ default: confetti }) => {
      if (cancelled) return;

      confetti({
        particleCount: 80,
        angle: -60,
        spread: 70,
        startVelocity: 35,
        origin: { x: 0, y: 0 },
        colors: PALETTE,
        zIndex: 60,
      });
      confetti({
        particleCount: 80,
        angle: 240,
        spread: 70,
        startVelocity: 35,
        origin: { x: 1, y: 0 },
        colors: PALETTE,
        zIndex: 60,
      });
    });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (streamers.length === 0) return null;

  return (
    <div
      className="anniversary-decoration fixed inset-0 z-40 overflow-hidden pointer-events-none"
      aria-hidden="true"
    >
      {streamers.map((s) => (
        <span
          key={s.id}
          className="anniversary-decoration__streamer"
          style={{
            "--left": `${s.leftPct}%`,
            "--delay": `${s.delaySec}s`,
            "--duration": `${s.durationSec}s`,
            "--rotate": `${s.rotateDeg}deg`,
            "--color": s.color,
          }}
        />
      ))}
    </div>
  );
}
